module.exports = "<div class=\"mobile-display\"></div>\r\n<div class=\"desktop-display\"></div>\r\n";